import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Paginated } from '@sd-portal/shared/models';

import { AuditLogLite, FleetAuditTail } from './+models/fleet-audit.model';

@Injectable()
export class FleetAuditService {
  private readonly apiUrl = '/sdapi/post-flight/audit/fleet';

  constructor(private readonly http: HttpClient) {}

  getTails(pageNumber: number, pageSize: number): Observable<Paginated<FleetAuditTail>> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.http.get<Paginated<FleetAuditTail>>(`${this.apiUrl}/tails`, { params });
  }

  getTailLogs(
    tailId: number,
    pageNumber: number,
    pageSize: number
  ): Observable<Paginated<AuditLogLite>> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.http.get<Paginated<AuditLogLite>>(`${this.apiUrl}/tails/${tailId}/logs`, {
      params
    });
  }
}
